module.exports = __webpack_public_path__ + "static/media/calendar.18e7b8d2.svg";